import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import validateRequestError from '../util/error/validateRequestError';

export const DELETE_COUPON_CODE_MUTATION = gql`
  mutation DeleteCouponCode($id: String!) {
    deleteCouponCode(id: $id)
  }
`;

export const useDeleteCouponCode = () => {
  const [deleteCouponCode] = useMutation(DELETE_COUPON_CODE_MUTATION);

  const deleteCoupon = async (id: string) => {
    await validateRequestError(deleteCouponCode({variables: {id}}));
    return true;
  };

  return deleteCoupon;
};
